import { PreferenceDefaultInvestorGroupResponse, UserPreferenceName, UserPreferencesState } from "@user/models";

export const convertIAGroupId = (
  investorAccountGroupId: PreferenceDefaultInvestorGroupResponse["value"]
): UserPreferencesState[UserPreferenceName.UserDefaultInvestorsGroup] =>
  investorAccountGroupId === "ALL" || investorAccountGroupId === "all" || investorAccountGroupId === null
    ? null
    : Number(investorAccountGroupId);
